

const { IS_STAGING, IS_PRODUCTION_MODE } = function () {
    const IS_STAGING = process.env.NODE_ENV !== 'production';
    const IS_PRODUCTION_MODE = !IS_STAGING;
    return { IS_STAGING, IS_PRODUCTION_MODE };
}()

export const ENV = {
    IS_STAGING,
    IS_PRODUCTION_MODE,
    SITE_URL: process.env.NEXT_PUBLIC_FRONTEND_URL || 'http://localhost:3000',
    // 
    SITE_NAME: process.env.NEXT_PUBLIC_SITE_NAME || 'Tablatures-Harmonica',
    ENVIRONMENT: process.env.ENVIRONMENT,
    NEXT_PUBLIC_ENV: process.env.NEXT_PUBLIC_ENV,
    ANALYTICS_ENDPOINT: process.env.NEXT_PUBLIC_ANALYTICS_ENDPOINT || '/api/analytics',
    BACKEND_URL: process.env.BACKEND_URL || 'http://localhost:8080',

    // Analytics
    ANALYTICS_ENABLED: process.env.NEXT_PUBLIC_ANALYTICS_ENABLED === 'true',
    ANALYTICS_API_KEY: process.env.NEXT_PUBLIC_ANALYTICS_API_KEY,
    // Google Analytics
    GA_ID: process.env.NEXT_PUBLIC_GA_ID || 'G-BMFP8QXLEM',
    GA_ADSENSE_ID: process.env.NEXT_PUBLIC_GA_ADSENSE_ID || 'ca-pub-7963289265738576',

    // Umami (self-hosted, cookieless) - complements Google Analytics
    UMAMI_SRC: process.env.NEXT_PUBLIC_UMAMI_SRC || 'https://stats.computingsquare.com/script.js',
    UMAMI_WEBSITE_ID: process.env.NEXT_PUBLIC_UMAMI_WEBSITE_ID || 'e3a5c151-fb8e-4e1f-9629-9060f42bb5cc',

    //Facebook 
    FACEBOOK_APP_ID: process.env.NEXT_PUBLIC_FACEBOOK_APP_ID || '',

    // Google
    GOOGLE_CLIENT_ID: process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID || '',
    // reCAPTCHA v3 site key. Read at request time by server components (no NEXT_PUBLIC_ build-time inlining)
    RECAPTCHA_SITE_KEY: process.env.RECAPTCHA_SITE_KEY || '',
} 